// src/pages/AnalyticsQualityAssessmentsPage.jsx
import {useState, useEffect, Fragment} from 'react';
import api from '../../services/api';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import Pagination from '../../components/Pagination';
import useAuth from "../../hooks/useAuth";

const AnalyticsQualityAssessmentsPage = () => {
  const { user: currentUser } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    project_id: '',
    date_filter_from: '',
    date_filter_to: ''
  });
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    if (filters.project_id) {
      fetchData();
    }
  }, [filters.project_id, filters.date_filter_from, filters.date_filter_to]);

  const fetchProjects = async () => {
    try {
      const res = await api.get('/projects');
      setProjects(res.data.projects || []);
    } catch (err) {
      console.error('Ошибка загрузки проектов:', err);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append('project_id', filters.project_id);
      if (filters.date_filter_from) params.append('from_date', filters.date_filter_from);
      if (filters.date_filter_to) params.append('to_date', filters.date_filter_to);

      const res = await api.get('/quality/assessment-selection/with-assessment', { params });
      setData(res.data.data || []);
    } catch (err) {
      console.error('Ошибка загрузки выборок с оценками:', err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };
  console.log('data: ', data)
  const [expandedAssessments, setExpandedAssessments] = useState(new Set());

  const toggleAssessment = (assessmentId) => {
    setExpandedAssessments(prev => {
      const newSet = new Set(prev);
      if (newSet.has(assessmentId)) {
        newSet.delete(assessmentId);
      } else {
        newSet.add(assessmentId);
      }
      return newSet;
    });
  };

  return (
    <div className="main-content">
      <div className="analytics-header mb-4">
        <h1>Аналитика по оценкам в анализе</h1>
      </div>

      <div className="mb-4">
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">Проект</label>
            <select
              name="project_id"
              className="form-select"
              value={filters.project_id}
              onChange={handleFilterChange}
            >
              <option value="">Выберите проект</option>
              {projects.map(project => (
                <option key={project.id} value={project.id}>{project.name}</option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">Дата от</label>
            <input
              type="date"
              name="date_filter_from"
              className="form-control"
              value={filters.date_filter_from}
              onChange={handleFilterChange}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Дата до</label>
            <input
              type="date"
              name="date_filter_to"
              className="form-control"
              value={filters.date_filter_to}
              onChange={handleFilterChange}
            />
          </div>
        </div>
      </div>

      {loading ? (
        <LoadingSpinner text="Загружаем данные..." />
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped-columns">
            <thead>
              <tr>
                <th>Оценка ID</th>
                <th>Дата звонка</th>
                <th>Создано</th>
                <th>Оценка</th>
                <th>Оценка создана</th>
                <th>Оценка обновлена</th>
                <th>%</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center text-muted py-4">
                    <strong>Нет данных для отображения</strong>
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <Fragment key={index}>
                    <tr 
                      onClick={() => toggleAssessment(item.assessment.id)}
                      style={{ cursor: 'pointer' }}
                    >
                      <td>{item.selection.quality_assessment_id}</td>
                      <td>{new Date(item.sound.date_sound).toLocaleString()}</td>
                      <td>{new Date(item.selection.created_at).toLocaleString()}</td>
                      <td>{item.assessment.id}</td>
                      <td>{new Date(item.assessment.created_at).toLocaleString()}</td>
                      <td>{new Date(item.assessment.updated_at).toLocaleString()}</td>
                      <td>{item.assessment.total_score * 100} %</td>
                    </tr>
                    {expandedAssessments.has(item.assessment.id) && (
                      <tr>
                        <td colSpan="7">
                          <table className="table table-sm table-bordered mb-0">
                            <thead>
                              <tr>
                                <th>criteria_id</th>
                                <th>criteria_name</th>
                                <th>option_text</th>
                                <th>positive</th>
                                <th>score</th>
                                <th>weight</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.assessment.items.map((item, itemIndex) => (
                                <tr key={itemIndex}>
                                  <td>{item.criteria_id}</td>
                                  <td>{item.criteria_name}</td>
                                  <td>{item.option_text}</td>
                                  <td>{item.positive ? 'Да' : 'Нет'}</td>
                                  <td>{item.score}</td>
                                  <td>{item.weight}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AnalyticsQualityAssessmentsPage;
